// src/components/ChatGPT4/ChatOutput.js

import React from 'react';
import PropTypes from 'prop-types';

const ChatOutput = ({
  output,
  copyToClipboard,
  handleSend,
  handleClear,
}) => (
  <div>
    <textarea
      value={output}
      readOnly
      placeholder="Response will appear here"
    />
    <button type="button" onClick={copyToClipboard}>Copy</button>
    <button type="button" onClick={handleSend}>Send to Main Text Box</button>
    <button type="button" onClick={handleClear}>Clear</button>
  </div>
);

ChatOutput.propTypes = {
  output: PropTypes.string.isRequired,
  copyToClipboard: PropTypes.func.isRequired,
  handleSend: PropTypes.func.isRequired,
  handleClear: PropTypes.func.isRequired,
};

export default ChatOutput;
